import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

/**
 * Shell del backoffice: sidebar a sinistra, topbar in alto, contenuto pagina
 * nel main area (scrollabile, padding standard).
 */
export function Layout() {
  return (
    <div className="flex h-screen overflow-hidden bg-bg-0 text-text">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
